import { Component, input } from '@angular/core';

@Component({
  selector: 't-workflow-ai-icon',
  standalone: true,
  imports: [],
  templateUrl: './workflow-ai-icon.component.html',
  styleUrl: './workflow-ai-icon.component.css',
})
export class WorkflowAiIconComponent {
  size = input<number>(24);
}
